const useObserver = (entryEvent: any, outEvent: any, threshold: number) => {
  return new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entryEvent?.()
      } else {
        outEvent?.()
      }
    });
  }, { threshold });
}
export default useObserver